<template>
  <section>
    <qx-search-box
        class="searchBox"
        :searchBoxData="searchBoxData"
        @sub="sub"
        title="筛选"
        permpisionsQuery=""
    >
    </qx-search-box>
    <TableBox ref="tableBox" />
  </section>
</template>
<script>
import TableBox from './tableBox';
export default {
  components: {
    TableBox,
  },
  data () {
    return {
      searchBoxData: {
        form: [
          {
            label: '车牌号码',
            value: 'plateNumber',
            type: 'input',
            placeholder: '请输入车牌号码',
          },
          {
            label: '保养日期',
            value: 'serviveLoseDate',
            type: 'date',
            placeholder: '请输入保养日期',
            attr: {
              type: 'daterange',
            },
          },
        ],
      },
    };
  },
  methods: {
    sub (searchBoxData) {
      if (searchBoxData.serviveLoseDate && searchBoxData.serviveLoseDate.length) {
        searchBoxData.maintenanceDateStr = this.formatDate(searchBoxData.serviveLoseDate[0]);
        searchBoxData.maintenanceDateEnd = this.formatDate(searchBoxData.serviveLoseDate[1]);
      }
      delete searchBoxData.serviveLoseDate;

      this.$refs.tableBox.saveSearchBoxData({
        // vehicleCode: '',
        ...searchBoxData,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
